export enum IdProvider {
  CLASSPAD = "CLASSPAD",
  ISERV = "ISERV",
  MIL = "MIL",
  MOODLE = "MOODLE",
  GAR = "GAR",
  EDUPLACES = "EDUPLACES",
}
